// const getTextItems = () => {
// 	return [
//     {resellerId: 1, route: "home", section: "leadTitle", value: "Gadget Claims"},
//     {resellerId: 1, route: "home", section: "leadText", value: "You can make a claim and check on the progress of an existing claim by choosing from the options below."},
//     {resellerId: null, route: "policyLookup", section: "title", value: "Let's get started...", isDefault: true},
//     {resellerId: null, route: "policyLookup", section: "resume", value: "If you have a saved claim form that you wish to resume, <a href=\"#/makeaclaim/resume\">click here</a>.", isDefault: true}
//   ];
// }

// const TextManager = class
// {
// 	constructor(resellerId, textItems) {
//   	this._resellerId = resellerId;
//     this._textItems = [...textItems];
//   }
// 	getText(route,section) {
//   	if (!Array.isArray(this._textItems) /*|| this.textItems.length <= 0*/) {
//     	return null;
//     } else {
//     	const textItem = this._textItems.find(e => e.resellerId == this._resellerId && 
//       	e.route == route 
//         && e.section == section)
//       if (textItem) {
//       	return textItem.value;
//       } else {
//       	const defaultItem = this._textItems.find(e => e.isDefault == true 
//         	&& e.route == route 
//           && e.section == section)
//         if (defaultItem) {
//         	return defaultItem.value;
//         } else {
//         	return null;
//         }
//       }
//     }
//   }
// }

// const textManager = new TextManager(1, getTextItems());
// console.log(textManager.getText("home", "leadTitle"));
// console.log(textManager.getText("home", "leadText"));
// console.log(textManager.getText("policyLookup", "title"));
// console.log(textManager.getText("policyLookup", "resume"));

// Load for route then getText has smaller arry to look through!

export function getTextItems() {
    return [
      {resellerId: null, route: "home", section: "leadTitle", value: "Gadget Claims", isDefault: true},
      {resellerId: null, route: "home", section: "leadText", value: "You can make a claim and check on the progress of an existing claim by choosing from the options below.", isDefault: true},
      {resellerId: null, route: "policylookup", section: "title", value: "Let's get started...", isDefault: true},
      {resellerId: null, route: "policydetails", section: "title", value: "Your details...", isDefault: true},
      {resellerId: null, route: "incidenttypes", section: "title", value: "What are you claiming for...", isDefault: true},
      {resellerId: null, route: "aboutYou", section: "title", value: "A couple of questions about you...", isDefault: true},
      {resellerId: null, route: "incidentDetails", section: "title", value: "A couple of questions about the incident...", isDefault: true},
      {resellerId: null, route: "gadgetlist", section: "title", value: "What gadget(s) do you wish to claim for?", isDefault: true},
      {resellerId: null, route: "supportingDocs", section: "title", value: "The following documents help us process your claim...", isDefault: true},
      {resellerId: null, route: "declartion", section: "title", value: "Please make sure you have read and understood the following statements...", isDefault: true},
      {resellerId: null, route: "reviewv2", section: "title", value: "Please check the details that you have provided...", isDefault: true},
      {resellerId: null, route: "thankyou", section: "title", value: "Thank you for submitting your claim", isDefault: true},
      {resellerId: null, route: "contact", section: "title", value: "Contact us...", isDefault: true},
      {resellerId: null, route: "login", section: "title", value: "Please login...", isDefault: true},
      {resellerId: null, route: "resetpassword", section: "title", value: "Reset password...", isDefault: true},
      {resellerId: null, route: "change", section: "title", value: "Change password...", isDefault: true},
      {resellerId: null, route: "resume", section: "title", value: "Saved claim form details", isDefault: true},

      {resellerId: 77, route: "policylookup", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "policydetails", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "incidenttypes", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "aboutYou", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "incidentDetails", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "policylookup", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "gadgetlist", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "gadgetDetails", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "supportingDocs", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "declartion", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "reviewv2", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "thankyou", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "contact", section: "leadTitle", value: "Contact us", sectionClass: "middle-title"},
      {resellerId: 77, route: "contact", section: "title", value: null, sectionClass: null},
      {resellerId: 77, route: "login", section: "leadTitle", value: "Your account", sectionClass: "middle-title"},
      {resellerId: 77, route: "resetpassword", section: "leadTitle", value: "Your account", sectionClass: "middle-title"},
      {resellerId: 77, route: "changepassword", section: "leadTitle", value: "Your account", sectionClass: "middle-title"},
      {resellerId: 77, route: "resume", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "claimslist", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "viewclaim", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "uploaddocs", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptions", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionslist", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionsinfo", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionsinstructions", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionscancel", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionsbankdetails", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionseditbankdetails", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionsuploaddocs", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},

      {resellerId: 999, route: "test", section: "test", value: "test"},

      {resellerId: 123, route: "declartion", section: "dataprotection", value: "We may use the personal and business details you give us, or which are supplied by third parties, to consider your claim and carry out other enquiries as we may consider necessary to evaluate the claim and assist in making a decision regarding the claim, and for compliance business reviews. We may also share these details with other insurance organisations and selected other parties to handle claims and prevent fraud. Personal details may be transferred to countries outside of the United Kingdom or European Economic Area. They will at all times be held securely and handled with the upmost care in accordance with all principles of the law. We will store personal details on computer but will not keep them for longer than necessary, which is usually 7 years for an insurance claim. For full details of how we process your personal data, including where to review our privacy notices, please refer to your policy wording."},    
      {resellerId: 123, route: "declartion", section: "fraud", value: "Deliberately exaggerated claims could invalidate your policy cover.  Insurance fraud is a crime and liable to prosecution. The above answers to our questions will be the basis of consideration of your claim. You must ensure that all information is true, correct and complete to the best of your knowledge and belief. In order to prevent and detect fraud we may at any time: • Share information about you with other organisations and public bodies, including the Police. • Check and/or file your details with fraud prevention agencies and databases. • If false or inaccurate information is provided and fraud is identified, details will be passed to fraud prevention agencies. • Law enforcement agencies may access and use this information."},    
      {resellerId: 123, route: "declartion", section: "accurate", value: "I declare that all information is true, accurate and completed to the best of my knowledge and belief and that all facts have been disclosed. I understand that the information may be checked and passed to other insurance companies or organisations to prevent fraud and I consent to such checks being made and the sharing of my information. I understand that if I make a claim which is false, exaggerated or fraudulent in any way, my claim will not be paid, the insurance will be void with no refund of premium and details of the fraud will be passed to the appropriate authorities for prosecution. If fraud is suspected then details will be passed to the police for further investigation. In the event of my gadget not appearing on the Police Stolen Equipment National Database, I understand that Taurus will register the details. I understand that if my gadget is replaced, the damaged or lost item is no longer my property and ownership will be transferred to Taurus."},
    ];
}

export class TextManager {
	constructor(options) {
    
    // create dict with route as key to improve search?

  	if (options) {
    	this._resellerId = options.resellerId;
      if (options.hasOwnProperty("route") && options.route != null && options.route != undefined ) {
      	this._route = options.route;
      	this._textItems = options.textItems.filter(i => i.route === this._route && (i.resellerId === this._resellerId || i.isDefault === true));
      } else {
      	this._textItems = options.textItems.filter(i => i.resellerId === this._resellerId || i.isDefault === true);
      }
    } else {
    	throw "Options must be provided!";
    }
  }
  getText(section, route) {
    const textItem = this.getTextItem(section, route);
    if (textItem) {
      return textItem.value;
    } else {
      return null;
    }
  }
  getTextItem(section, route) {
        if (!Array.isArray(this._textItems) /*|| this.textItems.length <= 0*/) {
        return null;
      } else {
        if (this.hasOwnProperty("_route") && this._route != null && this._route != undefined ) {
          route = this._route;
        }
        const textItem = this._textItems.find(e => e.resellerId == this._resellerId &&
              e.route == route
          && e.section == section)
        if (textItem) {
              return textItem;
        } else {
              const defaultItem = this._textItems.find(e => e.isDefault == true
              && e.route == route
            && e.section == section)
          if (defaultItem) {
              return defaultItem;
          } else {
              return null;
          }
        }
      }      
  }
  getTextItems(route) {
  	return this._textItems.filter(i => i.route === route);
  }
  getEmpty() {
    return {resellerId: null, route: null, section: null, value: null, sectionClass: null}
  }
}